import * as React from 'react';
import styled from 'styled-components';
import { COLOURS, FONT_WEIGHT, isFocused } from '@belong/themes';

export const FeedbackWrapper = styled.div`
  border-top: 1px solid ${COLOURS.GREY_400};
  padding: 16px;
`;

export const StarWrapper = styled.div`
  display: flex;
  margin-top: 16px;
`;

export const Title = styled.span`
  font-weight: ${FONT_WEIGHT.SEMI_BOLD};
`;

export const PlainButton = styled.button`
  all: unset;
  line-height: 1rem;

  :not(:disabled) {
    cursor: pointer;
  }

  &:focus {
    ${isFocused()}
  }
`;

export const Star = () => (
  <svg width="44" height="42" viewBox="0 0 44 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 1.61804L26.6883 16.0471L26.8006 16.3926H27.1638H42.3355L30.0613 25.3103L29.7675 25.5238L29.8797 25.8693L34.568 40.2984L22.2939 31.3807L22 31.1672L21.7061 31.3807L9.43199 40.2984L14.1203 25.8693L14.2325 25.5238L13.9387 25.3103L1.66454 16.3926H16.8362H17.1994L17.3117 16.0471L22 1.61804Z"
      stroke="#B3B3B3"
    />
  </svg>
);
Star.displayName = 'Star';

export const StarSelected = () => (
  <svg width="44" height="42" viewBox="0 0 44 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 0L27.1638 15.8926H43.8743L30.3552 25.7148L35.5191 41.6074L22 31.7852L8.48094 41.6074L13.6448 25.7148L0.1257 15.8926H16.8362L22 0Z"
      fill="#FFB38A"
    />
  </svg>
);
StarSelected.displayName = 'StarSelected';

export const CloseButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 6px;
`;
